import { render, staticRenderFns } from "./AccountServicePage.vue?vue&type=template&id=7c5a2e2e&scoped=true"
import script from "./AccountServicePage.vue?vue&type=script&lang=js"
export * from "./AccountServicePage.vue?vue&type=script&lang=js"
import style0 from "./AccountServicePage.vue?vue&type=style&index=0&id=7c5a2e2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5a2e2e",
  null
  
)

export default component.exports